//
//
//
//
//
//

export default {
  props: {
    shortname: {
      type: String,
    },
    label: {
      type: String,
    },
    longname: {
      type: String,
    },
  },

}



// WEBPACK FOOTER //
// ./src/components/formulaComponent/unit.vue